import React from 'react';
import RelatedArticles from './RelatedArticles';
import Articles from './Articles';
import ErrorBoundary from './ErrorBoundary';
import { Blog } from 'apolloClient/types/Blog';
import {
  getSmallImageUrlFromImage,
  getThumbnailImageUrlFromImage,
} from 'lib/getImages';

interface RelatedArticlesSectionProps {
  blogs: Blog[];
  showButtonMore?: string;
}

export const RelatedArticlesSection: React.FC<RelatedArticlesSectionProps> = ({
  blogs,
  showButtonMore = 'mb-[67px]',
}) => {
  return (
    <ErrorBoundary>
      <RelatedArticles name="Related articles" showButtonMore={showButtonMore}>
        {blogs?.map((blog: Blog, index) => {
          return (
            <Articles
              href={`/blog/${blog.slug}`}
              key={blog.id || index}
              topics={blog?.blogTags}
              {...(blog?.mainImage?.data?.attributes
                ? {
                    imageUrl: getSmallImageUrlFromImage(
                      blog?.mainImage?.data?.attributes
                    ),
                    blurredImageUrl: getThumbnailImageUrlFromImage(
                      blog?.mainImage?.data?.attributes
                    ),
                  }
                : {})}
              imageAlt={blog.title}
              title={blog.title}
              description={blog.shortDescription || ''}
            />
          );
        })}
      </RelatedArticles>
    </ErrorBoundary>
  );
};
